import { module } from 'angular';
import { CgMetadataDirective } from './directives/cg-metadata';
export var ngModule = module('gn.audio.cg.metadata', []).directive('cgMetadata', CgMetadataDirective);
